import { type MouseEvent } from 'react';
import FilesUploadIcon from '../../images/files.svg?react';

export interface FilesProps {
  selectFilesClick: (e: MouseEvent) => void;
}

export default function FilesUpload({ selectFilesClick }: FilesProps) {
  return (
    <FilesUploadIcon
      onClick={(e) => {
        selectFilesClick(e);
      }}
    />
  );
}
